import {
    RESET_GROUP_PAGE,
    GROUP_PAGE_INIT_COURSE_TAB,
    GROUP_PAGE_INIT_COURSE_TAB_DONE,
    GROUP_PAGE_ADD_GROUP_COURSE_DONE,
    GROUP_PAGE_DELETE_GROUP_COURSE,
    GROUP_PAGE_DELETE_GROUP_COURSE_DONE,
    GROUP_PAGE_FETCH_COURSE_DETAIL,
    GROUP_PAGE_FETCH_COURSE_DETAIL_DONE,
    GROUP_PAGE_CLEAR_LAST_DELETE_COURSE_NAME,
    GROUP_PAGE_CLOSE_DELETE_COURSE_ERROR_DIALOG
} from '../../actions/ActionTypes';

import { omitInState } from './groupPageHelper';

const INITIAL_STATE = {
    fetching: false,
    error: false,
    userCourses: [],
    groupCourses: [],
    groupCourseDetail: {},
    deleting: [],
    deleteFailed: [],
    sendingToDevice: [],
    lastDeleteCourseName: ''
};

/** selector */

export const selectGroupPageCourse = (state) => state.groupPageCourse;

export const selectGroupPageCourseFetching = (state) => {
    const groupPageCourse = selectGroupPageCourse(state);
    return groupPageCourse.fetching;
};

export const selectGroupPageUserCourses = (state) => {
    const groupPageCourse = selectGroupPageCourse(state);
    return groupPageCourse.userCourses;
};

export const selectGroupPageGroupCourses = (state) => {
    const groupPageCourse = selectGroupPageCourse(state);
    return groupPageCourse.groupCourses;
};

export const selectGroupPageGroupCourseDetailFetching = (state, { courseId }) => {
    const groupPageCourse = selectGroupPageCourse(state);
    const courseDetail = groupPageCourse.groupCourseDetail[courseId];
    if (!courseDetail) {
        return true;
    }
    return courseDetail.fetching;
};

export const selectGroupPageGroupCourseDetailData = (state, { courseId }) => {
    const groupPageCourse = selectGroupPageCourse(state);
    const courseDetail = groupPageCourse.groupCourseDetail[courseId];
    if (!courseDetail) {
        return null;
    }
    return courseDetail.data;
};

export const selectGroupPageCourseDeleting = (state, { courseId }) => {
    const groupPageCourse = selectGroupPageCourse(state);
    return groupPageCourse.deleting.includes(courseId);
};

export const selectGroupPageCourseSendingToDevice = (state, { courseId }) => {
    const groupPageCourse = selectGroupPageCourse(state);
    return groupPageCourse.sendingToDevice.includes(courseId);
};

export const selectLastDeleteCourseName = (state) => {
    const groupPageCourse = selectGroupPageCourse(state);
    return groupPageCourse.lastDeleteCourseName;
};

export const selectGroupPageCourseDeleteFailedName = (state) => {
    const groupPageCourse = selectGroupPageCourse(state);
    if (!groupPageCourse.deleteFailed.length) {
        return '';
    }
    const courseId = groupPageCourse.deleteFailed[0];
    const groupCourse = groupPageCourse.groupCourses.find((item) => item.courseId === courseId);
    if (!groupCourse) {
        return '';
    }
    return groupCourse.courseName;
};

/** action handlers */
const initCourseTab = (state) => {
    return {
        ...state,
        fetching: true
    };
};

const initCourseTabDone = (state, action) => {
    return {
        ...state,
        fetching: false,
        error: action.error,
        userCourses: action.userCourses,
        groupCourses: action.groupCourses
    };
};

const addGroupCourseDone = (state, action) => {
    return {
        ...state,
        groupCourses: [...state.groupCourses, action.newCourse]
    };
};

const deleteGroupCourse = (state, action) => {
    return {
        ...state,
        deleting: [...state.deleting, action.groupCourseId],
        deleteFailed: state.deleteFailed.filter((item) => item !== action.groupCourseId)
    };
};

const deleteGroupCourseDone = (state, action) => {
    const newDeleting = state.deleting.filter((item) => item !== action.groupCourseId);
    if (action.error) {
        return {
            ...state,
            deleting: newDeleting,
            deleteFailed: [...state.deleteFailed, action.groupCourseId]
        };
    }
    const deleteCourse = state.groupCourses.find((item) => item.courseId === action.groupCourseId);
    return {
        ...state,
        deleting: newDeleting,
        deleteFailed: state.deleteFailed.filter((item) => item !== action.groupCourseId),
        groupCourses: state.groupCourses.filter((item) => item.courseId !== action.groupCourseId),
        groupCourseDetail: omitInState(state.groupCourseDetail, action.groupCourseId),
        lastDeleteCourseName: (deleteCourse && deleteCourse.courseName) || ''
    };
};

const fetchGroupCourseDetail = (state, action) => {
    return {
        ...state,
        groupCourseDetail: {
            ...state.groupCourseDetail,
            [action.groupCourseId]: {
                ...state.groupCourseDetail[action.groupCourseId],
                error: false,
                fetching: true
            }
        }
    };
};

const fetchGroupCourseDetailDone = (state, action) => {
    return {
        ...state,
        groupCourseDetail: {
            ...state.groupCourseDetail,
            [action.groupCourseId]: {
                ...state.groupCourseDetail[action.groupCourseId],
                error: action.error,
                fetching: false,
                data: action.groupCourseDetail
            }
        }
    };
};

const clearLastDeleteCourseName = (state) => {
    return {
        ...state,
        lastDeleteCourseName: ''
    };
};

const clearDeleteCourseErrorDialog = (state) => {
    return {
        ...state,
        deleteFailed: state.deleteFailed.slice(1)
    };
};

const resetGroupPage = () => {
    return INITIAL_STATE;
};

const handlers = {
    [GROUP_PAGE_INIT_COURSE_TAB]: initCourseTab,
    [GROUP_PAGE_INIT_COURSE_TAB_DONE]: initCourseTabDone,
    [GROUP_PAGE_ADD_GROUP_COURSE_DONE]: addGroupCourseDone,
    [GROUP_PAGE_DELETE_GROUP_COURSE]: deleteGroupCourse,
    [GROUP_PAGE_DELETE_GROUP_COURSE_DONE]: deleteGroupCourseDone,
    [GROUP_PAGE_FETCH_COURSE_DETAIL]: fetchGroupCourseDetail,
    [GROUP_PAGE_FETCH_COURSE_DETAIL_DONE]: fetchGroupCourseDetailDone,
    [GROUP_PAGE_CLEAR_LAST_DELETE_COURSE_NAME]: clearLastDeleteCourseName,
    [GROUP_PAGE_CLOSE_DELETE_COURSE_ERROR_DIALOG]: clearDeleteCourseErrorDialog,
    [RESET_GROUP_PAGE]: resetGroupPage
};

export default function groupPageCourseReducer(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];
    if (!handler) {
        return state;
    }
    return handler(state, action);
}
